<script lang="ts">
	import type { Post } from '$lib/api/rpc';
	import { onMount } from 'svelte';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import Document from '$lib/components/Post/PostBlock/Blocks/Document.svelte';
	import Video from '$lib/components/Post/PostBlock/Blocks/Video.svelte';
	import Loading from '$lib/components/Post/PostBlock/Blocks/Loading.svelte';
	import Image from '$lib/components/Post/PostBlock/Blocks/Image.svelte';
	import { page } from '$app/stores';
	import { NodeViewWrapper } from 'svelte-tiptap';
	import DragAndDropWrapper from '$lib/components/TextEditor/Components/DragAndDropWrapper/DragAndDropWrapper.svelte';
	import type { Editor, NodeViewProps } from '@tiptap/core';
	import { fileUploadStore } from '$lib/components/FileUploader/fileUploadStore';
	import { addPreviewImages, removePreviewImages } from '$textEditor/PostComposer/composerStore';

	export let node: NodeViewProps['node'];
	export let deleteNode: () => void;
	export let updateAttributes: NodeViewProps['updateAttributes'];
	export let editor: Editor;

	if (!$page.data.respHub || !$page.data.restApi)
		throw new Error('TextEditor Image: Missing hub or restApi');

	const hubId = $page.data.respHub.hub.id;
	const restApi = $page.data.restApi;

	let uploading = false;
	let post: Post | null;

	const handleDocumentUpload = async () => {
		const file = $fileUploadStore[$fileUploadStore.length - 1];
		$fileUploadStore = [];
		if (!file) return;
		uploading = true;
		editor.setEditable(false);
		const response = await restApi.uploadFile(hubId, file);
		if (response.error) {
			toastMessages.danger('', response.error);
			deleteNode();
		} else {
			if (response.data) {
				post = response.data.asset;
				updateAttributes({ post });
				if (post.title_image?.url) addPreviewImages([post.title_image.url]);
			}
		}
		uploading = false;
		editor.setEditable(true);
	};

	onMount(async () => {
		post = node.attrs.post;

		if (!post) {
			await handleDocumentUpload();
			return;
		}
		if (post.title_image?.url) addPreviewImages([post.title_image.url]);
	});
	const deleteNodeWrapper = () => {
		if (post?.title_image?.url) removePreviewImages([post?.title_image.url]);
		editor.setEditable(true);
		deleteNode();
	};
</script>

<NodeViewWrapper>
	<DragAndDropWrapper on:delete={deleteNodeWrapper}>
		{#if uploading}
			<Loading />
		{:else if post}
			<div>
				{#if post.type === 'document'}
					<Document bind:block={post} editable />
				{:else if post.type === 'video'}
					<Video bind:block={post} editable />
				{:else if post.type === 'photo'}
					<Image block={post} />
				{/if}
			</div>
		{/if}
	</DragAndDropWrapper>
</NodeViewWrapper>
